import { defineModel } from '@tencent/tica';
import { THRID_CHANNLE, LOGIN_ERROR, THRID_CHANNLE_NAME } from '../config';
import {
  intlThirdLogin,
  emailSendVerifyCode,
  verifyCodeRegister,
  queryEmailUserName,
  intlSignIn,
  JumpToThridLogin,
} from '../utils';
import { service } from '../sevice';

const modelDefinition = defineModel({
  state: {
    gameAccountInfo: {},
    error: 0,
    loginLoading: false,
  },
  actions: {
    closeLoading() {
      this.set({ loginLoading: false });
    },
    async thridLogin(channel: THRID_CHANNLE, cache: boolean) {
      try {
        const thridAccountInfo = await JumpToThridLogin(channel);

        // 获取第三方平台token后，查询该账号是否在游戏注册
        if (thridAccountInfo && thridAccountInfo.ret === 0) {
          this.set({ loginLoading: true });

          const { data: hasGameAccount } = await service.intlCheck({
            channelInfo: thridAccountInfo,
            channelId: channel,
          });

          // 有账号直接登陆intl
          if (hasGameAccount) {
            const gameAccountInfo = await intlThirdLogin(THRID_CHANNLE_NAME[channel], thridAccountInfo);
            console.log('gameAccountInfo', gameAccountInfo);
            const { openid, token, ret } = gameAccountInfo;

            if (openid && token) {
              const campAccount: any = await service.campLogin(
                {
                  channelId: channel,
                  openId: openid,
                  token,
                },
                cache,
              );

              console.log('campAccount', campAccount);
              // 登陆营地
              if (Number(campAccount.code) !== 0) {
                return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
              }

              return campAccount;
            }
            if (ret === 11_015) {
              return { errCode: LOGIN_ERROR.IP_ERROR };
            }
            return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
          }
          // 无账号做出提示
          return { errCode: LOGIN_ERROR.NO_GAME_ACCOUNT };
        }
        if (thridAccountInfo.ret === 808_098_100) {
          return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
        }

        return { errCode: LOGIN_ERROR.LOGIN_ERROR };
      } catch (error) {
        console.log(error);
        return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
      }
    },
    async thridLoginWithoutCheck(channel: THRID_CHANNLE, cache: boolean) {
      try {
        const thridAccountInfo = await JumpToThridLogin(channel);

        // 获取第三方平台token后，查询该账号是否在游戏注册
        if (thridAccountInfo && thridAccountInfo.ret === 0) {
          this.set({ loginLoading: true });
          // 有账号直接登陆intl
          const gameAccountInfo = await intlThirdLogin(THRID_CHANNLE_NAME[channel], thridAccountInfo);
          console.log('gameAccountInfo', gameAccountInfo);
          const { openid, token, ret } = gameAccountInfo;

          if (openid && token) {
            const campAccount: any = await service.campLogin(
              {
                channelId: channel,
                openId: openid,
                token,
              },
              cache,
            );

            console.log('campAccount', campAccount);
            // 登陆营地
            if (Number(campAccount.code) !== 0) {
              return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
            }
            return campAccount;
          }
          if (ret === 11_015) {
            return { errCode: LOGIN_ERROR.IP_ERROR };
          }
          return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
        }
        if (thridAccountInfo.ret === 808_098_100) {
          return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
        }

        return { errCode: LOGIN_ERROR.LOGIN_ERROR };
      } catch (error) {
        console.log(error);
        return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
      }
    },
    async emailVarify(email: string) {
      console.log(this);
      // 查询改邮箱是否注册
      const emailInfo = await queryEmailUserName(email);
      if (emailInfo.is_register) {
        // 向该邮箱发送验证码
        emailSendVerifyCode(email).catch(() => {
          // 发送失败
          return { errCode: LOGIN_ERROR.SEND_VERIFY_CODE_ERROR };
        });
      } else {
        // 提醒用户该账号未注册
        return { errCode: emailInfo.ret === 1005 ? LOGIN_ERROR.SEND_VERIFY_CODE_ERROR : LOGIN_ERROR.NO_GAME_ACCOUNT };
      }
    },
    emailLogin: async (email: string, verifyCode: string, cache: boolean) => {
      const intlAccount = await verifyCodeRegister(email, verifyCode);
      console.log('intlAccount', intlAccount);
      if (intlAccount) {
        // intl账号登陆成功，换取游戏账号
        const { token, uid } = intlAccount;
        const gameAccountInfo = await intlSignIn(email, token, uid).catch(() => {
          console.log('gameAccountInfo error');
          return { errCode: LOGIN_ERROR.GAMG_LOGIN_ERROR };
        });
        if (gameAccountInfo) {
          const { openid, token, ret } = gameAccountInfo;

          if (openid && token) {
            // 登录营地账号
            const campAccount: any = await service.campLogin(
              {
                channelId: THRID_CHANNLE.EMAIL,
                openId: openid,
                token,
              },
              cache,
            );
            console.log('campAccount', campAccount);
            if (Number(campAccount.code) !== 0) {
              return { errCode: LOGIN_ERROR.CAMP_LOGIN_ERROR };
            }

            return campAccount;
          }
          if (ret === 11_015) {
            return { errCode: LOGIN_ERROR.IP_ERROR };
          }
          return { errCode: LOGIN_ERROR.GAMG_LOGIN_ERROR };
        }
        return { errCode: LOGIN_ERROR.NO_GAME_ACCOUNT };
      }
      // 尝试输入错误
      return { errCode: LOGIN_ERROR.LOGIN_ERROR };
    },
  },
  selectors: {},
});

export const useModel = modelDefinition.createReactHook();
